import './closeIcon.styl';

interface Props {
    onClick?: () => void;
    className?: string;
}

export const CloseIcon = ({ onClick }: Props) => {
    return (
        <div className="close-icon" onClick={onClick}>
            <span className="ico"></span>
        </div>
    );
};
